import { createSlice } from '@reduxjs/toolkit';

export const layoutSlice = createSlice({
    name: 'layout',
    initialState: {
        drawerIsOpen : true,
        itemSelected: null,
    },
    reducers: {
        closeDrawer: (state) => {
            state.drawerIsOpen = false
        },
        openDrawer: (state) => {
            state.drawerIsOpen = true
        },
        selectItem: (state, {payload}) => {
            state.itemSelected = payload
        }
    }
});

export const { closeDrawer, openDrawer, selectItem } = layoutSlice.actions;